import React, { lazy, Suspense } from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";
import Nav from "./components/Nav/Nav";
// import Footer from "./components/Footer/Footer";
import Loading from "./components/Loading/Loading";
import ScrollToTop from "./ScrollToTop";

const Login = lazy(() => import("./pages/Login"));
const AdminHome = lazy(() => import("./pages/AdminHome"));

const Router = () => {
  function RequireAuth({ children }) {
    const token = localStorage.getItem("token");
    let location = useLocation();

    if (!token) {
      return <Navigate to="/" state={{ from: location }} replace />;
    }
    return children;
  }
  return (
    <BrowserRouter>
      <Suspense fallback={<Loading />}>
        <Nav />
        <ScrollToTop />
        <Routes>
          <Route exact path="/" element={<Login />} />
          <Route
            exact
            path="/admin/home"
            element={
              <RequireAuth>
                <AdminHome />
              </RequireAuth>
            }
          />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
};

export default Router;
